<template>
    <div class="col-12 fiber-contact">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="info-box mt-3 alert-info alert-dismissible">
                    <span class="alert-icon"></span>
                    <div class="info-text my-0">
                        <span>{{$t("We need to check your eligibility for this offer. Please fill in your information and an agent will be in touch shortly.")}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
                <ValidationObserver ref="fiberInfo" v-slot="{ handleSubmit, invalid }">
                    <form name="callmebackfiber" id="callmebackfiber"
                          class="form form-fiber">
                        <fieldset class="fieldset fieldset-flex">
                            <div class="mt-3">
                                <div class="custom-control custom-checkbox registered">

                                    <input name="registered" id="registered" title="Registered"
                                           class="custom-control-input" type="checkbox" @click="orangeClient"
                                           v-model="registered">
                                    <label class="custom-control-label" for="registered">{{
                                            $t("I'm already a customer of Orange Luxembourg")
                                        }}</label>

                                </div>

                                <ValidationProvider name="lastname"
                                                    rules="required|minLetters|mustNotMatchAuthorizedCharacter"
                                                    v-slot="{ errors }">
                                    <div class="form-group lastname required">
                                        <label class="label" for="lastname">
                                            {{ $t('Last name') }}
                                        </label>

                                        <input name="lastname" id="lastname" :title="$t('Last name')" value=""
                                               class="form-control required required-entry" type="text"
                                               required="true"
                                               minlength="2"
                                               v-model="lastname">
                                        <span :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                                            {{ errors[0] }}
                                            </span>

                                    </div>
                                </ValidationProvider>
                                <ValidationProvider name="firstname"
                                                    rules="required|minLetters|mustNotMatchAuthorizedCharacter"
                                                    v-slot="{ errors }">
                                    <div class="form-group firstname required">
                                        <label class="label" for="firstname"> {{ $t('First name') }} </label>

                                        <input name="firstname" id="firstname" :title="$t('First name')" value=""
                                               class="form-control required-entry" type="text"
                                               required="true"
                                               minlength="2"
                                               v-model="firstname">
                                        <span :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                                            {{ errors[0] }}
                                            </span>

                                    </div>
                                </ValidationProvider>

                                <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                    <div class="form-group mail required">
                                        <label class="label" for="email">
                                            {{ $t('Email address') }}
                                        </label>

                                        <input name="email" id="email" :title="$t('Email address')" type="email"
                                               value="" class="form-control" v-model="email">
                                        <span :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                                            {{ errors[0] }}
                                            </span>

                                    </div>
                                </ValidationProvider>

                                <ValidationProvider name="samemail" rules="required|email|confirmEmail:email"
                                                    v-slot="{ errors }">
                                    <div class="form-group samemail required">
                                        <label class="label" for="samemail">
                                            {{ $t('Confirm your email address') }}
                                        </label>

                                        <input name="samemail" id="samemail" :title="$t('Confirm your email address')"
                                               value=""
                                               class="form-control"
                                               type="email"
                                               v-model="samemail">

                                        <span :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                                            {{ errors[0] }}
                                            </span>
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider name="phone" rules="required|regexPhone" v-slot="{ errors }">
                                    <div class="form-group phone required">
                                        <label class="label" for="phone">
                                            {{ $t('Phone number') + '*' }}
                                        </label>

                                        <input ref="phoneInput" name="phone"
                                               id="phone"
                                               :title="$t('Phone number')"
                                               value=""
                                               class="form-control"
                                               type="tel"
                                               v-model="phone"
                                               :maxlength="phoneNumberMaxLength"
                                               @keyup="formatWithSpace"
                                               :placeholder="placeholderPhoneNumber">
                                        <span v-if="showPhoneError" :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                                            {{ errors[0] }}
                                        </span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="u-marg-t-md u-marg-t-xs--xs fieldset-flex">
                                <button type="submit"
                                        class="btn btn-block btn-primary btn-lg gtm-form-cta-call-me-back call-me-align"
                                        title="Submit" :disabled="invalid || isLoading"
                                        @click.prevent="submitData">
                                    <span> {{ $t('Call Me Back') }} </span>
                                    <img
                                        v-show="isLoading"
                                        :src="planDataFromMagento.loaderUrl"
                                        class="ml-2"
                                        style="max-width: 16px;"
                                        alt=""/>
                                </button>
                            </div>
                        </fieldset>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>

import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import datasetExamplesPhoneNumber from 'libphonenumber-js/examples.mobile.json'
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {email, required} from 'vee-validate/dist/rules';
import { AsYouType, parsePhoneNumber, getExampleNumber } from 'libphonenumber-js/min';


import axios from 'axios';

export default {
    data() {
        return {
            registered: false,
            lastname: '',
            firstname: '',
            email: '',
            samemail: '',
            phone: '',
            phoneNumberMaxLength: '11',
            placeholderPhoneNumber: '628123456',
            isLoading: false,
            showPhoneError: false
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    async mounted() {
        this.extendValidation()
        this.phoneInput = intlTelInput(this.$refs.phoneInput, {
            initialCountry: "lu",
            preferredCountries: ['lu'],
            separateDialCode: true,
            preferredCountries: ['lu', 'fr', 'de', 'be', 'pt', 'it'],
            utilsScript: 'node_modules/intl-tel-input/build/js/utils.js' // Path to utils.js
        });

        if (this.phone.length > 0) {
        this.phone = this.phone.replace('+' + this.phoneInput.selectedCountryData.dialCode, '') // remove international number from the input
        await this.$refs.phoneInput.validate(this.phone)
        this.formatWithSpace()
      }
        window.dataLayer.push({
            'event': 'configurator_field',
            'step': 'fibre_information_step'
        });

        // Listen to country change event and update phone prefix
        this.$refs.phoneInput.addEventListener('countrychange', this.updatePhonePrefix);
    },
    // Make sure to destroy the instance when the component is destroyed
    beforeDestroy() {
        if (this.phoneInput && this.phoneInput.destroy) {
            this.phoneInput.destroy();
        }

        // Remove the event listener when the component is destroyed
        this.$refs.phoneInput.removeEventListener('countrychange', this.updatePhonePrefix);
    },

    props: {

        traduction: {
            type: Function
        },
        planDataFromMagento: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        $t() {
            return this.traduction
        },

    },
    methods: {
        formatWithSpace () {
        const iso = this.phoneInput.selectedCountryData.iso2.toUpperCase()
        const phoneNumberExample = getExampleNumber(iso, datasetExamplesPhoneNumber)
        const asYouType =  new AsYouType(iso)
        const asYouTypePlaceholder =  new AsYouType(iso)
        this.placeholderPhoneNumber = phoneNumberExample.nationalNumber

        asYouTypePlaceholder.input(phoneNumberExample.nationalNumber)

        this.phone = asYouType.input(this.phone)

        switch (iso) {
          case 'FR':
            this.phoneNumberMaxLength = 14 // 10 + 4 whitespace
          break;
          default:
            this.phoneNumberMaxLength = asYouTypePlaceholder.getTemplate().length > 11 ? asYouTypePlaceholder.getTemplate().length : 11
          break;
        }
      },
        orangeClient() {
            this.registered = !this.registered;
            console.log('registered', this.registered)
        },
        extendValidation() {
            extend('required', {
                ...required,
                message: this.$t('This field is required')
            });

            extend('minLetters', (value) => {
                if (value.length < 2) {
                    return this.$t('This field need to be at least 2 letters')
                } else {
                    return true
                }
            });
            extend('email', {
                ...email,
                message: this.$t('Please enter a valid email address')
            });
            extend('confirmEmail', (value) => {

                const email = document.getElementById('email')
                if (value !== email.value) {
                    return this.$t('Email confirmation does not match')
                } else {
                    return true
                }

            });

            extend('mustNotMatchAuthorizedCharacter', (value) => {
                const emojiRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/;
                const inputSpecialCharsRegex = /[`~!@#$%^&*()_|«»‹›“”„‘’‚…¡¿¨´^ˆ~˜¸,.:;·•¯‾–—_|¦†‡§¶©®™◊♠♣♥♦←↑→↓↔ƒ¥£¢≡≠≈=≥≤+×÷‰¼½¾¹²³ºªƒ∂∏∑√∞¬∩∫`+?;:",.<>{}[]]$/
                const numbersRegex = /[0-9]/

                if (value.match(inputSpecialCharsRegex) || value.match(numbersRegex) || value.match(emojiRegex)) {
                    return this.$t('This field must only contain letters')
                } else {
                    return true
                }
            });
            extend('regexPhone', (value) => {
                let phoneNumber = false;

                try {
                    phoneNumber = parsePhoneNumber('+' + this.phoneInput.selectedCountryData.dialCode + value);
                } catch {
                    return this.$t('Invalid phone number');
                }

                if (phoneNumber) {
                    if (phoneNumber.isValid()) {
                        return true;
                    } else {
                        return this.$t('Invalid phone number')
                    }
                } else {
                    return this.$t('Invalid phone number');
                }
            });
        },
        // async onSubmit() {
        //     this.contactSendSuccess = true
        //     const base_url = `${window.BASE_URL}` + 'contact_callback/index/submit/'

        //     // Make sure all fields are valid
        //     const isValid = await this.$refs.fiberInfo.validate()
        //     if (!isValid) return

        //     const phoneNumber = '+' + this.phoneInput.getSelectedCountryData().dialCode + this.phone;

        //     // console.log(this.$refs.fiberInfo.$data)
        //     // console.log(this.$refs.fiberInfo.$data.lastname)
        //     const request_data = {
        //         registered: this.registered,
        //         lastname: this.lastname,
        //         firstname: this.firstname,
        //         email: this.email,
        //         phone: phoneNumber,
        //         newsletter: false,
        //     }

        //     await axios.post(base_url, request_data, {
        //         headers: {
        //             content_type: 'application/json'
        //         },
        //         responseType: 'json',
        //     }).then((response) => {
        //         if (response.status === 200) {
        //             // Reuse existed page
        //             window.location.href = window.BASE_URL + 'contact-success';

        //             //show FiberContactSuccess.vue if contact form was successfull submited
        //             // this.$emit('fiber-contact-submit', true)
        //         }
        //     }).catch(function (error) {
        //         console.log(error);
        //     });
        // },
        formatAdress(item){
            if(item.building == null && item.floor == null && item.apartment == null){
                return '-'
            }else{
                let address = (item.building != null ? 'Building ' + item.building + ', ' : '') + (item.floor != null ? 'Floor. ' + item.floor + ', ': '') + (item.apartment != null ? 'Apt. ' + item.apartment : '')
                let returnAddress = address.substring(address.length - 2) === ', ' ? address.slice(0, -2) : address
                return returnAddress
            }
        },
        submitData(){
            const dataFromStorage = JSON.parse(window.localStorage.getItem('mage-cache-storage-installation'));
            const instalationAddress = dataFromStorage.address.additionalInfo;
            const additionalInfo = this.formatAdress(instalationAddress);
            const phoneNumber = '+' + this.phoneInput.selectedCountryData.dialCode + this.phone;
            this.isLoading = true;
            this.showPhoneError = true;

            let payload = {
                lastname: this.lastname,
                firstname: this.firstname,
                registered: this.registered,
                email: this.email,
                samemail: this.email,
                phone: phoneNumber,
                number: instalationAddress ? instalationAddress.streetNumber : '',
                street: instalationAddress ? instalationAddress.street : '',
                additional: additionalInfo ? additionalInfo : '',
                postcode: instalationAddress ? instalationAddress.completeZip : '',
                city: instalationAddress? instalationAddress.city : '',
            }

            fetch(`${window.BASE_URL}` + 'contact_callback/index/submit/', {
                method: 'POST',
                credentials: 'include',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(payload)
            })
            .then(response => {
                this.isLoading = false
                if(response.status === 200){
                    window.location.href = window.BASE_URL + 'contact-success';
                    // this.$emit('fiber-contact-submit', true)
                }
            })
        }
    }
}
</script>

